import {translateI18n} from '~/common/utils/i18n-helper'
// 支付收银台-线下转账信息
export const offlinePayeeInfo = [
  { id: '银行户名', name: '芯之元供应链管理（深圳）有限公司' },
  { id: '银行账号', name: '44250100002900003236' },
  { id: '开户银行', name: '建设银行深圳宝安路支行' }
];

// 支付收银台 基础信息字段
export const paymentField = [
  { name: 'order_number', type: 'readonly', placeholder: 'portal.ding-dan', span: 8 },
  { name: 'currency_code', type: 'readonly', placeholder: 'portal.bi-zhong', span: 8 },
  { name: 'total', type: 'readonly', placeholder: 'portal.jine', subType: 'money', currencyId: 'currency_id', span: 8, readonlyValClass: 'money', noSymbol: true }
  //   { name: 'account_name', type: 'readonly', placeholder: '付款账户：', span: 8 },
  //   { name: 'shop_member_name', type: 'readonly', placeholder: '交易员：', span: 8 },
  //   { name: 'TODO_skzh', type: 'readonly', placeholder: '收款账户：', span: 8 }
];

// 支付结果 基础信息字段
export const paymentResultField = [
  { name: 'collection_account_name', type: 'readonly', placeholder: 'portal.shou-kuan-hu-ming', span: 12 },
  { name: 'collection_number', type: 'readonly', placeholder: 'portal.shou-kuan-zhang-hao', span: 12 },
  { name: 'payment_account_name', type: 'readonly', placeholder: 'portal.fu-kuan-hu-ming', span: 12 },
  { name: 'payment_number', type: 'readonly', placeholder: 'portal.fu-kuan-zhang-hao', span: 12 },
  { name: 'captured_at', type: 'readonly', placeholder: 'portal.jiao-yi-shi-jian', subType: 'datetime', span: 12 },
  { name: 'amount', type: 'readonly', placeholder: 'portal.zhi-fu-jine', subType: 'money', currencyId: 'currency_id', span: 12 },
  { name: 'note', type: 'textarea', placeholder: 'common.remark', span: 24 }
];

// 交割支付结果基础信息字段
export const promptResultField = [
  { name: 'collection_card_name', type: 'readonly', placeholder: 'portal.shou-kuan-hu-ming', span: 12 },
  { name: 'collection_card_number', type: 'readonly', placeholder: 'portal.shou-kuan-zhang-hao', span: 12 },
  { name: 'pay_card_name', type: 'readonly', placeholder: 'portal.fu-kuan-hu-ming', span: 12 },
  { name: 'pay_card_number', type: 'readonly', placeholder: 'portal.fu-kuan-zhang-hao', span: 12 },
  { name: 'trade_time', type: 'readonly', placeholder: 'portal.jiao-yi-shi-jian', subType: 'datetime', span: 12 },
  { name: 'amount', type: 'readonly', placeholder: 'portal.zhi-fu-jine', subType: 'money', currencyId: 'currency_id', span: 12 },
  { name: 'description', type: 'textarea', placeholder: 'common.remark', span: 24 }
];

// 支付-收银台 表单校验
export const paymentRule = {
  password: [
    { required: true, message: translateI18n('portal.qing-shu-ru-zhi-fu-mi-ma'), trigger: 'change' },
    // { min: 6, max: 6, message: '密码错误，请重试！', trigger: 'blur' }
  ]
};

const prefix = '/rest/store/order/v3/';
// 支付-收银台
export const apiGetPaymentBalances = '/rest/store/hub/v3/payment/balances'; // 查询商户和成员余额
export const apiGetAccountBalances = '/rest/store/hub/v3/payment/cardBalances'; // 查询账户卡余额
export const apiCheckAccountCard = '/rest/store/hub/v3/payment/cardCheck'; // 校验佣金账户支付卡信息
export const apiGetPaymentCardInfo = '/rest/store/hub/v3/payment/cardQuery'; // 查询芯钱包下的支付信息
export const apiGetCardDetail = '/rest/store/hub/v3/nodeold/userWallet'; // 查询钱包详情  /rest/store/hub/v3/nodeold/queryCardDetail 记账卡详情接口替换为钱包接口
export const apiRechargeMoney = '/rest/store/hub/v3/txRequest/recharge'; // 给卡充值
export const apiSetCardPassword = '/rest/store/hub/v3/nodeold/updateCardPassword'; // 设置支付卡的密码
export const apiSubmitPayment = `${prefix}orders/payment`; // 支付
export const apiAutoPayment = `${prefix}orders/offline-payment`; // 自动支付
export const apiGetPaymentFlow = `${prefix}orders/payment/search`; // 查询支付流水列表
export const apiGetPaymentDetail = `${prefix}orders/payment/`; // 查询支付流水详情
// 查询销售跟单详情、采购跟单详情
export const apiGetBillDetail = `${prefix}orders/pending-payment/search`;
